module.exports={
	"Form": "ObservationApprovalStepEditManifest",
	"Scope": "ObservationApprovalStep-Edit",
	"Descriptors":
	{
		"ObservationApprovalStepDetails.IDObservationApprovalStep":
		{
			"Name": "ID",
			"Hash": "ObsStepEdit-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "ObsStepEditIdentity",
				"Group": "ObsStepEditIdentity"
			}
		},
		"ObservationApprovalStepDetails.GUIDObservationApprovalStep":
		{
			"Name": "GUID",
			"Hash": "ObsStepEdit-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "ObsStepEditIdentity",
				"Group": "ObsStepEditIdentity"
			}
		},
		"ObservationApprovalStepDetails.IDObservationApprovalState":
		{
			"Name": "State ID",
			"Hash": "ObsStepEdit-StateID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "2",
				"Width": 3,
				"Section": "ObsStepEditConfig",
				"Group": "ObsStepEditConfig"
			}
		},
		"ObservationApprovalStepDetails.Ordinal":
		{
			"Name": "Ordinal",
			"Hash": "ObsStepEdit-Ordinal",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "2",
				"Width": 2,
				"Section": "ObsStepEditConfig",
				"Group": "ObsStepEditConfig"
			}
		},
		"ObservationApprovalStepDetails.ObservationType":
		{
			"Name": "Observation Type",
			"Hash": "ObsStepEdit-ObsType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 3,
				"Section": "ObsStepEditConfig",
				"Group": "ObsStepEditConfig"
			}
		},
		"ObservationApprovalStepDetails.IDRole":
		{
			"Name": "Role ID",
			"Hash": "ObsStepEdit-IDRole",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "3",
				"Width": 3,
				"Section": "ObsStepEditConfig",
				"Group": "ObsStepEditConfig"
			}
		},
		"ObservationApprovalStepDetails.IncludeHigherRoles":
		{
			"Name": "Include Higher Roles",
			"Hash": "ObsStepEdit-HigherRoles",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "3",
				"Width": 2,
				"Section": "ObsStepEditConfig",
				"Group": "ObsStepEditConfig"
			}
		},
		"ObservationApprovalStepDetails.PerformLock":
		{
			"Name": "Perform Lock",
			"Hash": "ObsStepEdit-PerformLock",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "3",
				"Width": 2,
				"Section": "ObsStepEditConfig",
				"Group": "ObsStepEditConfig"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "ObsStepEditIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "ObsStepEditIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Step Configuration",
			"Hash": "ObsStepEditConfig",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Step Configuration",
					"Hash": "ObsStepEditConfig",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
